// extracted by mini-css-extract-plugin
module.exports = {"home_containter":"Home_home_containter__2PxwN"};